var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.70586H12.5V0.00585938H10.8333V1.70586H4.16667V0.00585938H2.5V1.70586H1.66667C1.22464 1.70586 0.800716 1.88497 0.488155 2.20378C0.175595 2.52259 0 2.95499 0 3.40586V15.3059C0 15.7567 0.175595 16.1891 0.488155 16.5079C0.800716 16.8268 1.22464 17.0059 1.66667 17.0059H13.3333C13.7754 17.0059 14.1993 16.8268 14.5118 16.5079C14.8244 16.1891 15 15.7567 15 15.3059V3.40586C15 2.95499 14.8244 2.52259 14.5118 2.20378C14.1993 1.88497 13.7754 1.70586 13.3333 1.70586ZM13.3333 15.3059H1.66667V6.80586H13.3333V15.3059ZM13.3333 5.10586H1.66667V3.40586H13.3333V5.10586ZM7.5 7.65586C9.16667 7.65586 10 9.71286 8.825 10.9199C7.64167 12.1269 5.625 11.2684 5.625 9.56836C5.625 8.50586 6.45833 7.65586 7.5 7.65586ZM11.25 14.3539V14.4559H3.75V14.3539C3.75 13.2914 5.41667 12.4414 7.5 12.4414C9.58333 12.4414 11.25 13.2914 11.25 14.3539Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.0091890b.svg";
export { ForwardRef as ReactComponent };